import { useQuery } from '@tanstack/react-query'

import { useAuth } from '@/hooks/use-auth'
import { ByWhom, getFolders, GetFoldersResponse } from '@/services/get-folders'

type HandleErrorMessage = (error: {
  title: string
  description: string
}) => void

function transformRawFolders(foldersList: GetFoldersResponse) {
  return foldersList.map((folder) => ({
    name: folder.name,
    description: folder.description,
    updatedAt: new Date(folder.updatedAt).toLocaleDateString('pt-BR'),
  }))
}

export const GET_FOLDERS_QUERY = 'folders'

export const useGetFolders = (
  byWhom: ByWhom,
  handleErrorMessage: HandleErrorMessage,
) => {
  const { user } = useAuth()

  const query = useQuery(
    [GET_FOLDERS_QUERY, byWhom],
    ({ signal }) => getFolders(user.id, byWhom, { signal }),
    {
      select: transformRawFolders,
      onError(err: Error) {
        handleErrorMessage({
          title: 'Ocorreu um erro',
          description: err.message,
        })
      },
    },
  )

  return query
}
